<template>
  <div class="o-form__block">
    <div class="m-field">
      <OQLabel :label="label" v-if="label" :required="required">
        <template v-if="error">
          <span class="error">{{ error }}</span>
        </template>
      </OQLabel>
      <input
        :class="{
          'a-input': true,
          'a-input_search': search,
        }"
        :disabled="disabled"
        @focus="(v) => $emit('focus', v)"
        @blur="(v) => $emit('blur', v)"
        :placeholder="placeholder"
        :value="value"
        @change="(v) => $emit('input', v.target.value)"
        @keyup="(v) => $emit('keypress', v.target.value)"
        :type="type"
      />
      <slot />
    </div>
  </div>
</template>

<script>
import OQLabel from "@/components/UI/OQLabel.vue";
export default {
  name: "OQInput",
  components: { OQLabel },
  props: [
    "label",
    "hint",
    "title",
    "placeholder",
    "value",
    "error",
    "disabled",
    "required",
    "search",
    "type",
  ],
};
</script>

<style scoped lang="scss">
.error {
  float: right;
  color: red;
}
</style>
